import { combineReducers } from "@reduxjs/toolkit";

import DashboardReducers from "./dashboard/reducers";
import SpaceReducers from "./space/reducers";

export default combineReducers({ ...DashboardReducers, ...SpaceReducers });
